export default "__VITE_ASSET__CMQ2$zjY__"